import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { any, element, func, string } from 'prop-types';
import React from 'react';
import { connect } from "react-redux";

var SearchBoxBase = /*#__PURE__*/function (_React$Component) {
  _inherits(SearchBoxBase, _React$Component);

  var _super = /*#__PURE__*/_createSuper(SearchBoxBase);

  function SearchBoxBase(props) {
    var _this;

    _classCallCheck(this, SearchBoxBase);

    _this = _super.call(this, props);
    _this.state = {
      query: _this.props.initValue || ""
    };
    return _this;
  }

  _createClass(SearchBoxBase, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.focus();
    }
  }, {
    key: "onSubmit",
    value: function onSubmit(e) {
      e.preventDefault();
      this.state.query && this.props.navigateTo("/search?q=".concat(encodeURIComponent(this.state.query)));
      this.props.onSubmitHandler && this.props.onSubmitHandler(this.state.query);
    }
  }, {
    key: "keyPress",
    value: function keyPress(e) {
      if (e.keyCode === 27) this.props.onEscape && this.props.onEscape();
    }
  }, {
    key: "focus",
    value: function focus() {
      this.textInput && this.textInput.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var Render = this.props.template || this.defaultTemplate;
      return /*#__PURE__*/React.createElement("form", {
        role: "search",
        action: "/search",
        onSubmit: function onSubmit(e) {
          return _this2.onSubmit(e);
        },
        className: this.props.className,
        ref: this.props.formRef
      }, /*#__PURE__*/React.createElement(Render, null, /*#__PURE__*/React.createElement("input", {
        type: "search",
        name: "q",
        placeholder: this.props.placeholder,
        value: this.state.query,
        onChange: function onChange(e) {
          return _this2.setState({
            query: e.target.value
          });
        },
        className: this.props.inputClassName,
        id: this.props.inputId,
        ref: function ref(input) {
          return _this2.textInput = input;
        },
        onKeyDown: function onKeyDown(e) {
          return _this2.keyPress(e);
        }
      })));
    }
  }], [{
    key: "defaultTemplate",
    value: function defaultTemplate(_ref) {
      var children = _ref.children;
      return children;
    }
  }]);

  return SearchBoxBase;
}(React.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    navigateTo: function navigateTo(url) {
      global.app.navigateToPage(dispatch, url);
    }
  };
};
/**
 * This component provides a form with a search text box. On submit, the user is redirected to the search page via AJAX.
 *
 * A template function can also be passed in, to do custom rendering. The template prop will be called with childen having the child text box.
 *
 * Example
 * ```javascript
 * import { SearchBox } from '@quintype/components';
 *
 * <SearchBox className="foobar" placeholder="search" inputClassName="foobar-box" inputId="stg" inputRef={(x) => this.foo = x} onEscape={() => this.closeDialog()}/>
 * ```
 * @component
 * @category Header
 */


export var SearchBox = /*#__PURE__*/connect(mapStateToProps, mapDispatchToProps)(SearchBoxBase);